module.exports = __webpack_public_path__ + "media/images/banners/donate_banner_background-994cd8de6d081b7386b7ed9a50f95be4.svg";